import React from 'react';
import CoreDivider from '../../Divider';

var Divider = function Divider() {
  return /*#__PURE__*/React.createElement(CoreDivider, null);
};

Divider.displayName = 'Divider';
export default Divider;